import React, { Component } from "react";
import { Form, Button, Icon, Modal, message, Card } from "antd";
import { Redirect } from "react-router-dom";
import "./LoginPage.css";
import { validateSenha, checkFormIsValid } from "../utils/Validator";
import { maskCPF } from '../utils/Masker'
import InputForm from "../components/InputForm";
import axios from "axios";
import { saveToken, savePermissoes, saveParametros, isLoggedIn } from '../utils/LoginManager';
import LogoP7 from '../imagens/logo-p7-pequeno.jpg';
import Cookies from 'universal-cookie';


const ItemForm = Form.Item;

export default class LoginPage extends Component {
  state = {
    usuario: "",
    senha: "",
    empresa: "0",
    empresaSelect: [],
    aguarde: false,
    habilitaEmpresa: false,

    ipExterno: '',
  };

  componentDidMount() {
    this.onBuscarIPClick();
  }


  onBuscarIPClick = () => {
    // console.log('onBuscarIPClick');
    fetch("http://ip-api.com/json")
      .then(res => res.json())
      .then(
        (result) => {
          // console.log('onBuscarIPClick-OK: ', result);
          const base64 = new Buffer(result.query + result.as + result.lat + result.lon + navigator.userAgent + navigator.deviceMemory + "GB" + navigator.hardwareConcurrency).toString('base64')
          // console.log('base64: ', base64);
          this.setState({ ipbase64: base64 });
        },
        (error) => {
          console.log('onBuscarIPClick-ERRO: ', error);
        }
      )
  }


  onLogin = event => {
    event.preventDefault();

    const formValid = checkFormIsValid(this.refs);
    if (formValid) {
      const { usuario, empresa, senha, ipExterno } = this.state;

      // console.log('onLogin: ', this.state);

      const body = {
        usuario: usuario.replace(/[^0-9]/g, ''),
        senha,
        empresa: empresa.key ? empresa.key : empresa,
        ipAtual: ipExterno,
        versao: 'web',
        plataforma: 'web',
        ipbase64: this.state.ipbase64,
      };

      this.setState({ aguarde: true });

      const request = axios.post("/usuarios/login", body);

      request.then(response => {
        this.setState({
          aguarde: false
        });
        saveToken(response.data.token); // grava o token no cookies
        savePermissoes(response.data.grupo);
        saveParametros();
        message.success('Login efetuado com sucesso.');
        this.props.history.push('/'); // vai para a página inicial
      });

      request.catch(error => {
        console.error(error.response);

        this.setState({
          aguarde: false
        });
        if (error.response) {
          if (error.response.status === 401) {
            Modal.error({ title: '', content: 'Usuário ou Senha Incorreto', });
          } else if (error.response.status === 402) {
            Modal.error({ title: '', content: 'Usuário sem acesso ao sistema P7 WEB', });
          } else {
            Modal.error({ title: '', content: 'Erro de conexão com o sistema.', });
          }
        } else {
          Modal.error({
            title: '',
            content: 'Não foi possível se comunicar com o servidor, verifique sua conexão com a internet.',
          });
        }
      });
    }
  };


  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onChangeEmpresa = event => {
    this.setState({
      empresa: event.target.value,
    });
  };

  onBlurCPF = event => {
    const value = event.target.value;
    this.setState({
      usuario: value,
    });
    this.buscaEmpresa(value);
  };

  buscaEmpresa = (value) => {
    const usu = value.replace(/[^0-9]/g, '');

    this.setState({
      empresa: "0",
      empresaSelect: [],
      carregando: false,
      habilitaEmpresa: false,
    });

    axios.get('/usuarios/empresasUsuario', {
      params: {
        ativo: 1,
        usuario: usu,
      }
    }).then(response => {
      const { data } = response;
      const empresaSelect = data.map(regList => {
        return {
          key: regList.emp_codigo,
          label: regList.emp_nome
        }
      });
      this.setState({
        empresaSelect,
      })

      if (data) {
        if (data.length > 1) {
          this.setState({
            habilitaEmpresa: true,
          });
        } else if (data.length === 1) {
          const empresa = data[0];
          this.setState({
            habilitaEmpresa: false,
            empresa: empresa.emp_codigo,
          });
          message.success('Usuário reconhecido');
        } else {
          message.success('Usuário não reconhecido');
        }
      } else {
        message.success('Usuário não reconhecido');
      }

    }).catch(error => {
      message.success('Usuário não reconhecido');
      console.error('Empresa do Usuário não encontrada. Erro.');
      console.error(error.response);
    })
  }







  render() {

    if (isLoggedIn()) {
      return (
        <Redirect to="/" />
      )
    }

    const { usuario, senha, aguarde, empresa, empresaSelect, habilitaEmpresa } = this.state;

    // console.log('LoginPage: ', this.state);

    return (
      <div className="login-fundo">

        <Card
          type="inner"
          bordered={false}
          className="login-form"
          bodyStyle={{ fontSize: 17, fontWeight: "bold", paddingTop: 10 }}
        >
          <Form onSubmit={this.onLogin}>

            <div className="login-imagem">
              <img alt="" src={LogoP7} />
            </div>

            <h1 style={{ color: "#004622" }}>Login P7 Vendas</h1>

            <InputForm
              id="usuario"
              ref="usuario"
              title="Digite o CPF"
              placeholder="CPF"
              prefix={<Icon type="user" />}
              size="large"
              maxLength={15}
              errorMessage="CPF Inválido"
              masker={maskCPF}
              value={usuario}
              onChange={this.onChange}
              onBlur={this.onBlurCPF}
            />

            <InputForm
              type="password"
              id="senha"
              ref="senha"
              title="Digite a Senha"
              placeholder="Senha"
              prefix={<Icon type="lock" />}
              size="large"
              maxLength={10}
              validator={validateSenha}
              value={senha}
              onChange={this.onChange}
              errorMessage="Senha Inválida"
            />

            {habilitaEmpresa ? (
              <InputForm
                type="select"
                id="empresa"
                ref="empresa"
                value={empresa}
                placeholder="Selecione uma Empresa"
                prefix={<Icon type="home" />}
                onChange={this.onChangeEmpresa}
                data={empresaSelect}
                validator={value => Boolean(value)}
                errorMessage="Informe a Empresa"
                showSearch
              />
            ) : null}

            <ItemForm>
              <Button
                htmlType="submit"
                className="login-botao"
                size="large"
                icon="login"
                loading={aguarde}
                disabled={empresa === '0'}
              >
                Entrar
              </Button>
            </ItemForm>
          </Form>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js